export const popularitySortOptions = [
  (course: { slug: string }) =>
    course.slug.startsWith("connectors")
      ? 11
      : course.slug.startsWith("intro-")
      ? 10
      : course.slug.startsWith("lift-off-part")
      ? 9
      : course.slug.startsWith("summit")
      ? 8
      : course.slug.startsWith("getting-started-with-graphos")
      ? 7
      : course.slug.startsWith("graphos-shipping")
      ? 6
      : course.slug.startsWith("graphos-growing")
      ? 5
      : course.slug.startsWith("voyage-part")
      ? 4
      : course.slug.startsWith("lift-off")
      ? 3
      : course.slug.startsWith("voyage")
      ? 2
      : course.slug.startsWith("side-quest")
      ? 1
      : 0,
  "slug",
];
